export const OPENAI_MODEL = "gpt-5-mini";